import React from "react";
import Input, { InputProps } from "antd/es/input/Input";

interface IProps extends InputProps
{
  className?: string;
  label?: string;
  required?: boolean;
  classNameDiv?: string;
}

export default function InputUI({
  className,
  label,
  classNameDiv,
  required,
  ...res
}: any)
{
  return (
    <div className={`${classNameDiv}`}>
      {label && (
        <p className="mb-2 text-[var(--color-text-select)] text-sm">
          {label}
          {required && <span className="text-common-red500">{` *`}</span>}
        </p>
      )}
      <Input
        {...res}
        className={`border-0  h-[34px] rounded-[2px]  !shadow-none${className ? " " + className : ""
          }`}
      />
    </div>
  );
}
